<script setup lang="ts">
// @ts-ignore
import i18n from '@/localization/i18n';
import { onBeforeUnmount, onMounted, Ref, ref, defineAsyncComponent, watch } from 'vue'
import ModalComponent from "@/views/components/ModalComponent.vue";
import digitalSignature from '@/assets/img/digital-signature-white.png'
import PublicLatestRequests from '@/pages/(public)/components/PublicLatestRequests.vue'
// import TopelaVideoPlayer from '@/pages/(public)/components/TopelaVideoPlayer.vue'

const Check = defineAsyncComponent(() => import('vue-material-design-icons/Check.vue'))
const InvoiceTextCheck = defineAsyncComponent(() => import('vue-material-design-icons/InvoiceTextCheck.vue'))
const WrenchCheck = defineAsyncComponent(() => import('vue-material-design-icons/WrenchCheck.vue'))

// Local variables
const t = i18n.global.t

// @ts-ignore
const VITE_ASSET_URL = import.meta.env.VITE_ASSET_URL

const topelaVideoPlayModalTrigger: Ref<any> = ref(null)

const screenSize = ref(0)

const backgroundPosition = ref('cover')

const isProAuthenticated = ref(false)


// const hero_image_mobile = `url(${VITE_ASSET_URL}assets/public/assets/img/ps/ps-header-bg_mobile.webp)`
// const hero_image_desktop = `url(${VITE_ASSET_URL}assets/public/assets/img/ps/ps-header-bg_desktop.webp)`
const ImageScreenshots = VITE_ASSET_URL + 'assets/public/assets/img/ps/Devices_transparent.png'

const setTimeoutId = ref<any | null>(null);

// @ts-ignore
function showVideo(event: any) {
  event.preventDefault();
  if (topelaVideoPlayModalTrigger !== null) {
    topelaVideoPlayModalTrigger.value.click()
    const video: any = document.getElementById('modalVideo')
    if (video !== null) {
      video.play()
    }

  }
}

function onModalHidden() {
  const video: any = document.getElementById('modalVideo')
  if (video !== null) {
    video.pause()
  }
}

function subscribeToTopela() {
  window.open(isProAuthenticated.value ? '/ps/home/' : '/ps/home/?next=singupScreenRoute', '_blank');
  // @ts-ignore
  window.dataLayer.push({
    event: "Lead",
    lead_source: "Pro subscription button",
    page_url: window.location.href,
  });
}

const scrollToSection = (id: string) => {
  const section = document.getElementById(id !== "client-user" ? id : id + '-replace')
  if (section) {
    setTimeoutId.value = setTimeout(() => {
      section.scrollIntoView({
        behavior: "smooth"
      })
    }, 500);
  }
};

const modalVideo: Ref<HTMLVideoElement | null> = ref(null)

const unwatchVideo = watch(modalVideo, (newVal) => {
  // console.log("modalVideo", modalVideo)
  if (newVal) {
    newVal.addEventListener('play', () => {
      // console.log("about to send video content event")
      // @ts-ignore
      window.dataLayer.push({
        event: "ViewContent",
        content_type: "product",
        content_name: "topela promo video",
        currency: "EUR",
        value: 0,
        content_category: "video",
        video_url: VITE_ASSET_URL + 'assets/public/assets/video/TOPELA.mp4'
      })
    })
  }
})

onMounted(() => {
  handleResize()
  isProAuthenticated.value = getAuthStatus()
  window.addEventListener('resize', handleResize);
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
  modalVideo.value?.removeEventListener('play', () => { });
  unwatchVideo();
  if (setTimeoutId.value !== null) clearTimeout(setTimeoutId.value);
  setTimeoutId.value = null;
});

const handleResize = () => {
  screenSize.value = window.innerWidth
  backgroundPosition.value = screenSize.value >= 576 ? 'center' : 'center'
};

const getAuthStatus = (): boolean => {
  let userData = localStorage.getItem("flutter.authResponse")
  if (userData && !isMobileDevice()) {
    return true
  } else {
    return false
  }
}

function isMobileDevice() {
  return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);
}
</script>

<template>
  <section class="pb-0">
    <div class="container " style="padding-top: 100px;">
      <div class="row align-items-center">

        <!-- ===== TEXTE ===== -->
        <div class="col-lg-7">

          <h1 class="fw-bold mb-3 display-3">
            {{ t("w_txt_psPresentation_manage_your_business") }}
          </h1>

          <p class="fs-5 text-muted mb-4">
            {{ t("w_txt_psPresentation_manage_your_business_description") }}<br></br> <strong>{{
              t("w_txt_psPresentation_manage_your_business_description_bold") }}</strong>.
          </p>

          <div class="row mb-3">
            <div class="col-md-6">
              <ul class="list-unstyled">
                <li class="d-flex align-items-start mb-2">
                  <span class="text-danger me-2 fs-5">✖</span>
                  {{ t("w_txt_psPresentation_inconvenience_01") }}
                </li>
                <li class="d-flex align-items-start mb-2">
                  <span class="text-danger me-2 fs-5">✖</span>
                  {{ t("w_txt_psPresentation_inconvenience_02") }}
                </li>
                <li class="d-flex align-items-start mb-2">
                  <span class="text-danger me-2 fs-5">✖</span>
                  {{ t("w_txt_psPresentation_inconvenience_03") }}
                </li>
              </ul>
            </div>

            <!-- Col droite (✅) -->
            <div class="col-md-6">
              <ul class="list-unstyled">
                <li class="d-flex align-items-start mb-2">
                  <span class="text-success me-2 fs-5">✔</span>
                  {{ t("w_txt_psPresentation_solution_01") }}
                </li>
                <li class="d-flex align-items-start mb-2">
                  <span class="text-success me-2 fs-5">✔</span>
                  {{ t("w_txt_psPresentation_solution_02") }}
                </li>
                <li class="d-flex align-items-start mb-2">
                  <span class="text-success me-2 fs-5">✔</span>
                  {{ t("w_txt_psPresentation_solution_03") }}
                </li>
              </ul>
            </div>
          </div>

          <!-- ===== BOUTONS (TES BOUTONS) ===== -->
          <div class="  d-flex flex-column flex-lg-row gap-3 my-4 w-100">
            <div class="col-12 col-md-6"><button class="btn btn-info flex-fill py-2 px-4 w-100"
                style="font-size: 20px !important;" @click="subscribeToTopela">
                {{ isProAuthenticated
                  ? t('w_txt_psHome_pro_space')
                  : t('w_act_psHome_subscribe_to_topela') }}
              </button>
            </div>
            <div class="col-12 col-md-6"><a class="btn btn-dark flex-fill py-2 px-4 bg-dark-blue w-100"
                style="font-size: 20px !important;" href="/contact/">
                {{ t('w_txt_psHome_demo_request') }}
              </a></div>
          </div>

          <p class="text-muted small text-center">
            {{ t("w_txt_psPresentation_no_credit_card") }}
          </p>
        </div>

        <!-- ===== VISUEL ===== -->
        <div class="col-lg-5 position-relative mt-4 mt-lg-0 d-flex justify-content-center align-items-center">

          <!-- Badge 10€ -->
          <div class="position-absolute badge rounded-circle bg-info text-dark fw-bold shadow border-2 border-dark"
            style="width:160px;height:160px;font-size:60px;display:flex;align-items:center;justify-content:center;top: 10%; right: 0%; z-index:10">
            {{ t("w_txt_psPresentation_price") }}<br />
            <p><small>{{ t("w_txt_psPresentation_price_period") }}</small></p>
          </div>

          <!-- Background + image -->
          <div class="w-100 d-flex justify-content-center" :style="{
            backgroundImage: `url(${VITE_ASSET_URL}assets/public/assets/img/topela_img_bg.png)`,
            backgroundSize: 'contain',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }">
            <img style="max-height: 600px; position: relative;" alt="Topela presentation"
              :src="VITE_ASSET_URL + 'assets/public/assets/img/pro_topela.png?'" />
          </div>

        </div>

      </div>
    </div>
  </section>

  <section class="py-0 text-white bg-dark-blue">
    <div class="container">
      <div class="row align-items-center g-4">

        <!-- VISUELS -->
        <div class="col-lg-5 d-flex justify-content-center">
          <div class="position-relative">
            <!-- Desktop -->
            <img class="img-fluid mb-3" :src="VITE_ASSET_URL + 'assets/public/assets/img/devices.png'"
              alt="Topela devices" />
          </div>
        </div>

        <!-- TEXTE -->
        <div class="col-lg-7">
          <h2 class="fw-semibold mb-3 text-white display-5">
            {{ t("w_txt_psPresentation_who_is_topela_for") }}
          </h2>

          <p class="fs-5 text-light opacity-90 mb-4">
            {{ t("w_txt_psPresentation_who_is_topela_for_description") }}
          </p>

          <ul class="list-unstyled fs-5 ps-5">
            <li class="d-flex align-items-start mb-3">
              <span class="me-2">👷‍♂️</span>
              <span><strong>{{ t("w_txt_psPresentation_who_is_topela_for_feature_01") }}</strong> {{
                t("w_txt_psPresentation_who_is_topela_for_feature_01_continued") }}</span>
            </li>
            <li class="d-flex align-items-start mb-3">
              <span class="me-2">📄</span>
              <span>{{ t("w_txt_psPresentation_who_is_topela_for_feature_02") }}</span>
            </li>
            <li class="d-flex align-items-start">
              <span class="me-2">💻</span>
              <span>{{ t("w_txt_psPresentation_who_is_topela_for_feature_03") }} <strong>{{
                t("w_txt_psPresentation_who_is_topela_for_feature_03_continued") }}</strong></span>
            </li>
          </ul>
        </div>

      </div>
    </div>
  </section>

  <PublicLatestRequests />

  <section class="py-5 bg-light">
    <div class="container">

      <!-- Titre -->
      <div class="text-center mb-5">
        <h2 class="fw-semibold">
          {{ t("w_txt_psPresentation_all_in_one_solution") }}
        </h2>
        <p class="text-muted fs-5 mt-2">
          {{ t("w_txt_psPresentation_all_in_one_solution_description") }}
        </p>
      </div>
      <!-- Badge -->
      <div class="d-flex justify-content-end mb-2">
        <span class="badge bg-success px-3 py-2 fs-6">
          {{ t("w_txt_psPresentation_all_in_one_solution_badge") }}
        </span>
      </div>

      <div class="accordion" id="topelaFeatures">
        <!-- ================== 3. DEMANDES DE CLIENTS ================== -->
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button class="accordion-button " data-bs-toggle="collapse" data-bs-target="#feat-3">
              {{ t("w_txt_psPresentation_feature_01_title") }}
            </button>
          </h2>
          <div id="feat-3" class="accordion-collapse collapse show" data-bs-parent="#topelaFeatures">
            <div class="accordion-body">

              <p class="fw-semibold">{{ t("w_txt_psPresentation_feature_01_features") }}</p>

              <ul>
                <li>
                  <strong>{{ t("w_txt_psPresentation_feature_01_access_demands") }}</strong>
                  <ul>
                    <li>{{ t("w_txt_psPresentation_feature_01_access_demands_list_item_01") }}</li>
                    <li>{{ t("w_txt_psPresentation_feature_01_access_demands_list_item_02") }}</li>
                  </ul>
                </li>

                <li class="mt-3">
                  <strong>{{ t("w_txt_psPresentation_feature_01_response_demands") }}</strong>
                  <ul>
                    <li>{{ t("w_txt_psPresentation_feature_01_response_demands_list_item_01") }}</li>
                    <li>{{ t("w_txt_psPresentation_feature_01_response_demands_list_item_02") }}</li>
                    <li>{{ t("w_txt_psPresentation_feature_01_response_demands_list_item_03") }}</li>
                  </ul>
                </li>
                <li class="mt-3">
                  <strong>{{ t("w_txt_psPresentation_feature_01_bonus_included") }} <span
                      class="badge badge-pill bg-success fs-6">{{
                        t("w_txt_psPresentation_feature_01_bonus_included_badge") }}</span></strong>
                  <ul>
                    <li>{{ t("w_txt_psPresentation_feature_01_bonus_included_list_item_01") }}</li>
                    <li>{{ t("w_txt_psPresentation_feature_01_bonus_included_list_item_02") }}</li>
                    <li>{{ t("w_txt_psPresentation_feature_01_bonus_included_list_item_03") }}</li>
                    <li>{{ t("w_txt_psPresentation_feature_01_bonus_included_list_item_04") }}</li>
                  </ul>
                </li>
              </ul>

            </div>
          </div>
        </div>
        <!-- ================== 1. DEVIS & FACTURES ================== -->
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button class="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#feat-1">
              {{ t("w_txt_psPresentation_feature_02_title") }}
            </button>
          </h2>
          <div id="feat-1" class="accordion-collapse collapse" data-bs-parent="#topelaFeatures">
            <div class="accordion-body">

              <p class="fw-semibold">{{ t("w_txt_psPresentation_feature_02_features") }}</p>

              <ul>
                <li>
                  <strong>{{ t("w_txt_psPresentation_feature_02_models") }}</strong>
                  <ul>
                    <li>{{ t("w_txt_psPresentation_feature_02_models_list_item_01") }}</li>
                    <li>{{ t("w_txt_psPresentation_feature_02_models_list_item_02") }}</li>
                    <li>{{ t("w_txt_psPresentation_feature_02_models_list_item_03") }}</li>
                  </ul>
                </li>

                <li class="mt-3">
                  <strong>{{ t("w_txt_psPresentation_feature_02_devis_client") }}</strong>
                  <ul>
                    <li>{{ t("w_txt_psPresentation_feature_02_devis_client_list_item_01") }}</li>
                    <li>{{ t("w_txt_psPresentation_feature_02_devis_client_list_item_02") }}</li>
                    <li>{{ t("w_txt_psPresentation_feature_02_devis_client_list_item_03") }}</li>
                    <li>{{ t("w_txt_psPresentation_feature_02_devis_client_list_item_04") }}</li>
                  </ul>
                </li>

                <li class="mt-3">
                  <strong>{{ t("w_txt_psPresentation_feature_02_invoices") }}</strong>
                  <ul>
                    <li>{{ t("w_txt_psPresentation_feature_02_invoices_list_item_01") }}</li>
                    <li>{{ t("w_txt_psPresentation_feature_02_invoices_list_item_02") }}</li>
                    <li>{{ t("w_txt_psPresentation_feature_02_invoices_list_item_03") }}</li>
                    <li>{{ t("w_txt_psPresentation_feature_02_invoices_list_item_04") }}</li>
                    <li>{{ t("w_txt_psPresentation_feature_02_invoices_list_item_05") }} <img style="height: 20px;"
                        src="https://anecs.anecs-cjec.org/wp-content/uploads/sites/2/2024/01/logo-pennylane.png"
                        alt="Pennylane" /></li>

                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- ================== 2. CHANTIERS & CLIENTS ================== -->
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button class="accordion-button collapsed " data-bs-toggle="collapse" data-bs-target="#feat-2">
              {{ t("w_txt_psPresentation_feature_03_title") }}
            </button>
          </h2>
          <div id="feat-2" class="accordion-collapse collapse" data-bs-parent="#topelaFeatures">
            <div class="accordion-body">

              <p class="fw-semibold">{{ t("w_txt_psPresentation_feature_03_features") }}</p>

              <ul>
                <li>
                  <strong>{{ t("w_txt_psPresentation_feature_03_projects") }}</strong>
                  <ul>
                    <li>{{ t("w_txt_psPresentation_feature_03_projects_list_item_01") }}</li>
                    <li>{{ t("w_txt_psPresentation_feature_03_projects_list_item_02") }}</li>
                    <li>{{ t("w_txt_psPresentation_feature_03_projects_list_item_03") }}</li>
                  </ul>
                </li>

                <li class="mt-3">
                  <strong>{{ t("w_txt_psPresentation_feature_03_clients") }}</strong>
                  <ul>
                    <li>{{ t("w_txt_psPresentation_feature_03_clients_list_item_01") }}</li>
                    <li>{{ t("w_txt_psPresentation_feature_03_clients_list_item_02") }}</li>
                    <li>{{ t("w_txt_psPresentation_feature_03_clients_list_item_03") }}</li>
                  </ul>
                </li>

                <li class="mt-3">
                  <strong>{{ t("w_txt_psPresentation_feature_03_messagerie_notifications") }}</strong>
                  <ul>
                    <li>{{ t("w_txt_psPresentation_feature_03_messagerie_notifications_list_item_01") }}</li>
                    <li>{{ t("w_txt_psPresentation_feature_03_messagerie_notifications_list_item_02") }}</li>
                  </ul>
                </li>
              </ul>

            </div>
          </div>
        </div>



        <!-- ================== 4. DÉPENSES & RENTABILITÉ ================== -->
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button class="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#feat-4">
              {{ t("w_txt_psPresentation_feature_04_title") }}
            </button>
          </h2>
          <div id="feat-4" class="accordion-collapse collapse" data-bs-parent="#topelaFeatures">
            <div class="accordion-body">

              <p class="fw-semibold">{{ t("w_txt_psPresentation_feature_04_included_features") }}</p>

              <ul>
                <li>
                  <strong>{{ t("w_txt_psPresentation_feature_04_expenses_tracking") }}</strong>
                  <ul>
                    <li>{{ t("w_txt_psPresentation_feature_04_expenses_tracking_list_item_01") }}</li>
                    <li>{{ t("w_txt_psPresentation_feature_04_expenses_tracking_list_item_02") }}</li>
                    <li>{{ t("w_txt_psPresentation_feature_04_expenses_tracking_list_item_03") }}</li>
                  </ul>
                </li>

                <li class="mt-3">
                  <strong>{{ t("w_txt_psPresentation_feature_04_financial_tracking") }}</strong>
                  <ul>
                    <li>{{ t("w_txt_psPresentation_feature_04_financial_tracking_list_item_01") }}</li>
                    <li>{{ t("w_txt_psPresentation_feature_04_financial_tracking_list_item_02") }}</li>
                  </ul>
                </li>
              </ul>

            </div>
          </div>
        </div>

        <!-- ================== 5. CONFORMITÉ & EXTRAS ================== -->
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button class="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#feat-5">
              {{ t("w_txt_psPresentation_feature_05_title") }}
            </button>
          </h2>
          <div id="feat-5" class="accordion-collapse collapse" data-bs-parent="#topelaFeatures">
            <div class="accordion-body">

              <p class="fw-semibold">{{ t("w_txt_psPresentation_feature_05_included_features") }}</p>

              <ul>
                <li>
                  <strong>{{ t("w_txt_psPresentation_feature_05_sap_mode") }}</strong>
                  <ul>
                    <li>{{ t("w_txt_psPresentation_feature_05_sap_mode_list_item_01") }}</li>
                    <li>{{ t("w_txt_psPresentation_feature_05_sap_mode_list_item_02") }}</li>
                    <li>{{ t("w_txt_psPresentation_feature_05_sap_mode_list_item_03") }}</li>
                  </ul>
                </li>

                <li class="mt-3">
                  <strong>{{ t("w_txt_psPresentation_feature_05_urssaf_status") }}</strong>
                  <ul>
                    <li>{{ t("w_txt_psPresentation_feature_05_urssaf_status_list_item_01") }}</li>
                    <li>{{ t("w_txt_psPresentation_feature_05_urssaf_status_list_item_02") }}</li>
                  </ul>
                </li>

                <li class="mt-3">
                  <strong>{{ t("w_txt_psPresentation_feature_05_electronic_billing") }}</strong>
                  <ul>
                    <li>{{ t("w_txt_psPresentation_feature_05_electronic_billing_list_item_01") }} <img
                        style="height: 20px;"
                        src="https://anecs.anecs-cjec.org/wp-content/uploads/sites/2/2024/01/logo-pennylane.png"
                        alt="Pennylane" /></li>
                    <li>{{ t("w_txt_psPresentation_feature_05_electronic_billing_list_item_02") }}</li>
                    <li>
                      <a href="https://www.impots.gouv.fr/professionnel/la-facturation-electronique-quest-ce-que-cest"
                        target="_blank" class="text-decoration-underline text-info">{{
                          t("w_txt_psPresentation_feature_05_electronic_billing_list_item_03") }}</a>
                    </li>
                  </ul>
                </li>

                <!-- <li class="mt-3">
                  <strong>{{ t("w_txt_psPresentation_feature_05_complementary_tools") }}</strong>
                  <ul>
                    <li>{{ t("w_txt_psPresentation_feature_05_complementary_tools_list_item_01") }}</li>
                    <li> {{ t("w_txt_psPresentation_feature_05_complementary_tools_list_item_02") }}</li>
                  </ul>
                </li> -->

              </ul>

            </div>
          </div>
        </div>

      </div>
    </div>
  </section>



</template>

<style scoped>
.topela-presentation-padding {
  padding-right: 60px !important;
}

.propsample-padding {
  padding-left: 130px !important;
  padding-right: 130px !important;
}

.mobile-feature-text {
  font-size: 10px;
  line-height: 1.3;
}

.desktop-feature-text {
  font-size: 12px;
  line-height: 1.3;
  font-weight: 530;
}

.text-container {
  text-align: center;
  color: white;
  margin-top: 2rem;
}

.features-content {
  display: flex;
  justify-content: space-around;
  background: white;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

.icon-item {
  flex: 1 1;
  text-align: center;
}

.icon-item-mobile {
  flex: 1 1 1;
  text-align: center;
}

.image-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  /* background-color: #00b5db; */
  border-radius: 50%;
}

.topela-blue-color {
  color: #49AFDA;
}

.topela-orange-color {
  color: #fcb33c;
}

.primary-btn {
  /* background-color: white;  */
  color: #233648;
  border: 1px solid #233648;
  /* border-radius: 10px; */
  /* font-weight: bold !important; */
  font-size: 20px !important;
}

.secondary-btn {
  background-color: #233648;
  color: white;
  /* padding: 10px 10px !important; */
  font-size: 20px !important;
  border: 1px solid #233648;
  /* font-weight: bold !important; */
}

.secondary-btn:hover {
  background-color: #49AFDA;
  color: #233648;
}

.play {
  align-items: center;
  justify-content: center;
  padding: 2px;
  border-radius: 50%;
  border: 2px solid white;
}

.video-link {
  color: white;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  text-decoration: underline;
}

.pros {
  color: white;
}

.quote {
  color: rgb(247, 242, 242);
  font-size: 18px;
  line-height: 1.5;
  font-style: italic;
  text-align: center;
}

.quote-author {
  color: rgb(243, 237, 237);
  font-size: 16px;
  text-align: center;
  margin-top: 10px;
}

/* Small devices (sm) - 576px and up */
@media (min-width: 576px) {
  /* Styles for small screens */
}

/* Medium devices (md) - 768px and up */
@media (min-width: 768px) {
  /* Styles for medium screens */
}

@media screen and (max-width: 992px) {
  .free-trial-info {
    font-size: smaller;
  }
}

.highlight {
  font-size: 3rem;
  font-weight: 900;
}

.highlight-blue {
  color: #49AFDA;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: 900;
  font-size: 5rem;

}

.highlight-script {
  /* font-family: 'Protest Riot', cursive; */
  font-style: italic;
  font-size: larger;
  font-weight: 900;
  position: relative;
  display: inline-block;
  padding-bottom: 5px;
  color: #49AFDA;
}

.highlight-script::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 8px;
  border-bottom: 2px solid #49AFDA;
  border-radius: 50%/100%;
  transform: scaleX(1.1);
  opacity: 0.5;
}

.pill-style {
  color: #233648;
  border-color: #233648;
  font-size: 1.5rem !important;
}

@media only screen and (max-width: 992px) {
  .pill-style {
    font-size: smaller !important;
  }

  .highlight {
    font-size: 1.5rem;
    font-weight: 900;
  }

  .highlight-blue {
    font-size: larger;
  }
}

@media screen and (max-width: 576px) {
  .hero-background {
    padding-top: 7rem !important;
  }

  .highlight {
    font-size: 2.5rem;
  }

  .highlight-blue {
    font-size: larger;
  }

  .highlight-script {
    font-size: 2.5rem;
  }

  .pill-style {
    font-size: 1rem !important;
  }

}

.bg-dark-blue {
  background-color: #233648 !important;

}
</style>